import { useEffect, EffectCallback, DependencyList } from 'react';

const noop = () => {};

function useIdleEffect(effect: EffectCallback, deps?: DependencyList) {
  useEffect(() => {
    const requestIdleCallbackShim =
      window.requestIdleCallback ||
      function (cb) {
        const start = Date.now();

        return setTimeout(() => {
          cb({
            didTimeout: false,
            timeRemaining() {
              return Math.max(0, 50 - (Date.now() - start));
            },
          });
        }, 1);
      };

    const cancelIdleCallbackShim =
      window.cancelIdleCallback ||
      function (id: number) {
        clearTimeout(id);
      };

    let cleanup = noop;

    const id = requestIdleCallbackShim(() => {
      cleanup = effect() || noop;
    });

    return () => {
      cancelIdleCallbackShim(id);
      cleanup();
    };
  }, deps);
}

export default useIdleEffect;
